import React from "react";
import { Link, InterfaceLink } from "@tiendanube/components";
import { Title, Text } from "../";
import classNames from "classnames";
import "./Card.scss";

export interface InterfaceCard {
  border?: boolean;
  title?: string;
  text?: string;
  link?: Pick<InterfaceLink, "children" | "icon" | "href">;
  children?: React.ReactNode;
  trimText?: boolean;
}

export interface InterfaceCardImage {
  imageDesktop?: string;
  imageMobile?: string;
  altText: string;
}

export interface InterfaceCardContent {
  children: React.ReactNode;
  direction?: "row" | "column";
}

function Card({
  border= false,
  title,
  text,
  link,
  children,
  trimText= true,
}: InterfaceCard): JSX.Element {
  const className = classNames("nimbus-web--card",{"nimbus-web--card--border": border},{"nimbus-web--card--trim-text": trimText});

  const content = title || text || link;

  return (
    <div className={className}>
      {children}
      {content && (
        <Card.Content>
          {title &&
            <Title size="h3">{title}</Title>
          }
          {text &&
            <Text size="medium">{text}</Text>
          }
          {link &&
            <Link icon={link.icon} appearance="primary" iconPosition="end" target="_blank" href={link.href}>{link.children}</Link>
          }
        </Card.Content>
      )}
    </div>
  );
}

function CardImage({
  imageDesktop,
  imageMobile,
  altText,
}: InterfaceCardImage): JSX.Element {
  const [width, setWindowWidth] = React.useState(0);

  React.useEffect(() => { 
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => 
      window.removeEventListener("resize",updateDimensions);
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
  }

  const responsive = {
    desktop: width > 1056
  }

  return (
    imageDesktop && imageMobile && (
      <div className="nimbus-web--card__image">
        {responsive.desktop ?
          <img src={imageDesktop} alt={altText} /> : <img src={imageMobile} alt={altText} />
        }
      </div>
    )
  )
}

function CardContent({
  children,
  direction= "column",
}: InterfaceCardContent): JSX.Element {
  const className = classNames("nimbus-web--card__content", `nimbus-web--card__content--${direction}`);

  return (
    <div className={className}>
      {children}
    </div>
  )
}

function CardDivider(): JSX.Element {
  return (
    <div className="nimbus-web--card__divider" />
  )
}

Card.Image = CardImage;
Card.Content = CardContent;
Card.Divider = CardDivider;

export default Card;